import {
  AboutUs_Screen,
  Blog_Screen,
  Home_Screen,
  Tech_Screen,
} from "../../../route/Routes";

export const link = [
  {
    link: Home_Screen,
    name: "Home",
  },
  {
    link: AboutUs_Screen,
    name: "About",
  },
  {
    link: Tech_Screen,
    name: "Tech Stack",
  },
  {
    link: Blog_Screen,
    name: "Blog",
  },
  {
    name: "Services",
  },
  {
    link: Tech_Screen,
    name: "Web Development",
  },
  {
    link: Tech_Screen,
    name: "App Development",
  },
  {
    link: Tech_Screen,
    name: "Digital Marketing",
  },
  {
    link: Tech_Screen,
    name: "E-Commerce",
  },
];
